<template>
  <div class="handle-button">
    <el-button v-if="circle" icon="el-icon-setting" circle size="mini" @click="handleShow"/>
    <el-button v-else size="mini" icon="el-icon-s-grid" @click="handleShow">显示列</el-button>
    <el-drawer :visible.sync="show" title="设置列" custom-class="set-tbl-columns-drawer">
      <div v-loading="load" class="set-tbl-columns-main">
        <div class="set-tbl-columns set-tbl-columns__left">
          <div class="set-tbl-columns__head" style="display: flex;align-items: center;justify-content: space-between">
            <div>
              请选择
              <span class="set-tbl-columns__head-tip" style="margin-right: 20px">共{{ columns.length }}项数据</span>
              <el-checkbox :indeterminate="check_all.is_half" v-model="check_all.value" @change="eventCheckAllChange">
                全选
              </el-checkbox>
            </div>
            <el-input
                placeholder="搜索字段"
                v-model="search_field"
                prefix-icon="el-icon-search"
                size="mini" style="width: 180px"
                clearable
            />
          </div>
          <div class="set-tbl-columns__part">
            <el-checkbox-group v-model="fields">
              <el-checkbox v-for="(item,item_i) in columns" :key="'checkbox'+item_i+item.name" :label="item.name"
                           @change="checked => eventChangeCheck(checked, item.name,item_i)"
                           :class="{active:search_field&&item.title.indexOf(search_field)>-1}"
                           :title="JSON.stringify(item)">
                {{ item_i + 1 }}、{{ item.title }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="set-tbl-columns set-tbl-columns__right">
          <div class="set-tbl-columns__head" style="display: flex;align-items: center;justify-content: space-between">
            <div>
              已选择：{{ columns_checked.length }}
            </div>
            <el-tooltip content="清空" placement="bottom" effect="light">
              <el-button size="mini" circle
                         style="width: 28px;height: 28px;display: flex;align-items: center;justify-content: center;"
                         @click="clear">
                <i class="iconfont icon-qingkongtuxing"/>
              </el-button>
            </el-tooltip>
          </div>
          <div class="set-tbl-columns__part">
            <draggable
                v-model="columns_checked"
                group="site"
                animation="100"
                drag-class="dragClass"
                ghost-class="ghostClass"
                chosen-class="chosenClass"
                filter=".forbid"
                :move="onMove"
                @start="onStart"
                @end="onEnd"
                style="height: 100%"
            >
              <transition-group style="width: 100%; height: 100%; display: inline-block;overflow-y: auto">
                <div
                    v-for="(item,index) in columns_checked"
                    :key="`a-${index}`"
                    class="column"
                >
                  <div :title="`${item.sort||0}`">
                    <i class="iconfont icon-tuozhuai2"/>
                    {{ index + 1 }}、 {{ item.title }}
                  </div>
                  <i class="el-icon-close delete" @click="eventDel(index,item.name)"/>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button round @click="show = false">取 消</el-button>
        <el-button round type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {getTableColsAll} from "../../../api/cache";
import draggable from "vuedraggable";
import {updateTableDisplay} from "../../../api/user";

export default {
  name: 'SetTblColumns',
  components: {draggable},
  props: {
    circle: Boolean
  },
  data() {
    return {
      show: false,
      load: false,
      search_field: null,
      check_all: {// 全选
        is_half: false,
        value: false,
      },
      fields: [],
      columns: [],
      columns_checked: [],
    }
  },
  created() {
  },
  methods: {
    handleShow: async function () {
      this.show = true
      this.load = true
      await this.getColumns();
      this.load = false
    },
    clear: function () {
      this.columns_checked = []
      this.fields = []
    },
    handleSubmit: async function () {
      const fields = this.columns_checked.map(_ => {
        return {name: _.name, display: true}
      })
      if (this.fields.length < 1) {
        this.showToast({
          h: this,
          icon: "el-icon-error",
          text: "最少选择一列",
          duration: 2000
        });
        return
      }
      await updateTableDisplay({type: 'ad_order', fields})
      this.show = false
      this.showToast({
        h: this,
        icon: "el-icon-success",
        text: "操作成功",
        duration: 2000
      });
      this.$emit('success')
    },
    /**
     * 不改变排序顺序
     * @param check
     * @param name
     * @param item_i
     */
    eventChangeCheck: function (check, name, item_i) {
      // eslint-disable-next-line no-console
      // console.log(item_i)
      if (check) {
        // 选中
        const tmp = this.columns.find(_ => _.name === name)
        if (tmp) {
          const posIndex = this.findMyPos(item_i)
          this.columns_checked.splice(posIndex, 0, tmp)
          // this.columns_checked.push(tmp)
        }
      } else {
        // 取消选中
        const index = this.columns_checked.findIndex(_ => _.name === name)
        this.columns_checked.splice(index, 1)
      }
      this.calcCheckAll()
    },
    findMyPos(index) {
      if (index === 0) {
        return 0
      }
      const len = this.columns_checked.length
      if (len === 0) {
        return 0
      }
      //上一列
      const preCol = this.columns[index - 1]
      if (!preCol) {
        return 0
      }
      // 并且已勾选，则在上一列后加当前列
      const preIndex = this.columns_checked.findIndex(value => value.name === preCol.name)
      if (preIndex > -1) {
        // eslint-disable-next-line no-console
        // console.log('上一列', preCol.title, preIndex)
        //若列号小于当前列
        if (preIndex < index) {
          // eslint-disable-next-line no-console
          // console.log("============= 若前一列现在的位置靠前，则选定===============")
          return preIndex + 1
        } else {

          // eslint-disable-next-line no-console
          // console.log("============= 若前一列现在的位置靠后，则排除===============")
          return this.findMyPos(index - 1)
        }
      } else {
        //往前找，直到没有
        return this.findMyPos(index - 1)
      }
    },

    /**
     * @param val
     */
    eventCheckAllChange: function (val) {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 200)
      setTimeout(() => {
        if (val) {
          const fields = []
          this.columns_checked = this.columns.map((_) => {
            fields.push(_.name)
            return _
          })
          this.fields = fields
        } else {
          this.fields = []
          this.columns_checked = []
        }

        this.calcCheckAll()
      }, 100)
    },
    getColumns: async function () {
      const {model: {tableCols, tableColsChoose}} = await getTableColsAll({type: 'ad_order'})
      this.columns = tableCols || []
      this.columns_checked = tableColsChoose || []
      this.fields = this.columns_checked.map(_ => {
        return _.name
      })

      this.calcCheckAll()
    },
    calcCheckAll: function () {
      this.check_all.value = this.columns_checked.length === this.columns.length
      this.check_all.is_half = this.fields.length > 0 && (this.fields.length < this.columns.length)
    },
    eventDel: function (index, name) {
      this.columns_checked.splice(index, 1)
      const fields_index = this.fields.findIndex(_ => _ === name)
      this.fields.splice(fields_index, 1)
    },
    onMove(e) {
      if (!e || !e.relatedContext || !e.relatedContext.element) {
        return true
      }
      return true
    },
    onStart() {
      this.drag = true
    },
    onEnd() {
      this.drag = false
    },
  }
}
</script>

<style lang="scss">
.set-tbl-columns-drawer {
  width: 1008px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
    background: #e8ebf2;
  }

  .footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
    height: 66px;
    opacity: 1;
    background: #fff;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, .04), 0 2px 4px 0 rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    z-index: 99;
  }

  .set-tbl-columns-main {
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: calc(100% - 106px);
    margin-top: 20px;
  }

  .set-tbl-columns {
    border-radius: 16px;
    background: #fff;

    &__head {
      padding: 16px 24px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      border-bottom: 1px solid #e4e7f0;

      &-tip {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-left: 12px;
      }
    }

    &__part {
      padding: 16px 24px;
      height: calc(100% - 115px);
      overflow-y: auto;


      .el-checkbox-group {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 5px 12px;

        .el-checkbox.active {
          background-color: #ffeef3;
        }

        .el-checkbox {
          padding: 4px 10px;
          border-radius: 6px;
          margin-right: unset;

          .el-checkbox__label {
            font-size: 12px;
          }
        }
      }

      .column.chosenClass {
        background-color: #ffeef3;
        color: #fe346e;
      }

      .column {
        border: 1px solid #e4e7f0;
        border-radius: 8px;
        padding: 0 8px;
        font-size: 12px;
        height: 28px;
        line-height: 28px;
        margin-bottom: 12px;
        cursor: move;
        transition: border-color 0.2s;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .iconfont {
          font-size: 12px;
          margin-right: 4px;
        }

        .delete {
          color: #ff3176;
          cursor: pointer;
          font-size: 14px;
          opacity: 0;
          transform: scale(.85);
          transition: all var(--duration);
        }
      }

      .column:hover {
        border-color: #ff3176;

        .delete {
          opacity: 1;
        }
      }
    }
  }

  .set-tbl-columns__left {
    width: calc(100% - 320px);
  }

  .set-tbl-columns__right {
    width: 300px;
    position: relative;
  }

  .set-tbl-columns__right:after, .set-tbl-columns__right:before {
    //-o-border-image: linear-gradient(45deg,transparent,#E03F3D) 1;
    border-image: linear-gradient(45deg, transparent, #E03F3D) 1;
    border-radius: 2px;
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: " ";
    height: 10px;
    left: -20px;
    margin-top: -8px;
    opacity: .8;
    position: absolute;
    top: 50%;
    transform: rotate(45deg);
    width: 10px;
  }

  .set-tbl-columns__right:before {
    margin-left: 4px;
  }

  .set-tbl-columns__right:after {
    margin-left: -4px;
  }
}
</style>
